import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { ChartRenderContext } from "../../../lib/core";
import { CHART_MARGIN } from "../../utils/widgetHelpers";
import { EventMarkerIcon } from "./EventMarkerIcon";
export function CorporateEventsOverlay({ events = [], showEvents = true, isMobile = false, axisClearancePx = CHART_MARGIN.bottom + 4, onEventClick, }) {
    const context = useContext(ChartRenderContext);
    const [hoveredEventId, setHoveredEventId] = useState(null);
    if (!showEvents || !context)
        return null;
    const { xScale, width } = context;
    // Filter events that are within the current visible viewport
    const visibleEvents = events.filter(e => {
        const x = xScale(new Date(e.timestamp));
        return x >= 0 && x <= width;
    });
    const getEventColor = (type) => {
        switch (type) {
            case "D": return "#10b981"; // Emerald green
            case "S": return "#3b82f6"; // Blue
            case "E": return "#f59e0b"; // Amber/orange
            case "N": return "#ec4899"; // Pink
            default: return "#9ca3af";
        }
    };
    return (_jsx("div", { style: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            zIndex: 20,
        }, children: visibleEvents.map(e => {
            const x = xScale(new Date(e.timestamp));
            const color = getEventColor(e.type);
            const isHovered = hoveredEventId === e.id;
            const markerSize = isMobile ? 20 : 16;
            return (_jsxs("div", { "data-event-badge": e.id, style: {
                    position: "absolute",
                    left: `${x}px`,
                    bottom: `${axisClearancePx}px`,
                    transform: "translateX(-50%)",
                    pointerEvents: "auto",
                }, children: [_jsx("button", { type: "button", onClick: () => onEventClick?.(e), onMouseEnter: () => setHoveredEventId(e.id), onMouseLeave: () => setHoveredEventId(null), style: {
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            outline: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "transform 0.15s ease",
                            transform: isHovered ? "scale(1.25)" : "none",
                        }, children: _jsx(EventMarkerIcon, { type: e.type, size: markerSize }) }), isHovered && (_jsxs("div", { style: {
                            position: "absolute",
                            bottom: `${markerSize + 6}px`,
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(20, 24, 33, 0.95)",
                            backdropFilter: "blur(12px)",
                            border: "1px solid rgba(255, 255, 255, 0.15)",
                            borderRadius: "6px",
                            padding: "8px 12px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
                            minWidth: "180px",
                            zIndex: 1000,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                        }, children: [_jsx("div", { style: {
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                    borderBottom: `1px solid ${color}`,
                                    paddingBottom: "4px",
                                    marginBottom: "2px",
                                }, children: e.title }), _jsx("div", { style: { fontSize: "11px", color: "#d1d4dc", whiteSpace: "normal" }, children: e.description })] }))] }, e.id));
        }) }));
}
